// extracted by mini-css-extract-plugin
export default {"select":"Companies_select__kvc4K","wrapper":"Companies_wrapper__cZOzc"};